module.exports = __webpack_public_path__ + "4937747ad18c8db97e29d6d4fcf923d7.fbx";